import React, { useState, useEffect } from 'react';
import './Hero.css';
import whatsappIcon from '../images/whatsappicon.png';
import BookingModal from './BookingModal';

const Hero = ({ settings = {} }) => {
  const [language, setLanguage] = useState('de');

  // Function to get saved language
  const getSavedLanguage = () => {
    return localStorage.getItem('selectedLanguage') || 'de';
  };

  // Initialize language
  useEffect(() => {
    const savedLang = getSavedLanguage();
    setLanguage(savedLang);
  }, []);

  const {
    title = 'RESTAURANT DAMAS',
    subtitle = '36 Jahre Erfahrung direkt zu Ihnen!',
    description = 'Reservieren Sie einen Tisch in unserem Restaurant. Wählen Sie Ihre bevorzugte Kontaktmethode:',
    buttonText = '',
    buttonLink = '',
    backgroundImage = 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1920&h=1080&fit=crop&crop=center',
    showBookingButtons = true,
    textColor = 'white',
    bookingButtonText = 'Tisch Reservieren',
    bookingButtonColor = '#FF7A00',
    emailButtonText = 'Email Reservierung',
    whatsappButtonText = 'WhatsApp',
    whatsappNumber = '+41438182912',
    whatsappMessage = 'Hallo! Ich möchte einen Tisch in unserem Restaurant reservieren.',
  } = settings;

  // Modal state for booking
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section className='hero'>
        <div className='hero-background'>
          <img
            src={backgroundImage}
            alt='Hero background'
            className='hero-bg-image'
          />
        </div>

        <div className='hero-content'>
          <div className='hero-text' style={{ color: textColor }}>
            <h1 className='hero-title'>{title}</h1>
            {subtitle && <h2 className='hero-subtitle'>{subtitle}</h2>}
            {description && <p className='hero-description'>{description}</p>}

            {/* Booking Button */}
            {showBookingButtons && (
              <div className='booking-buttons'>
                <button
                  className='booking-btn simple-booking-btn'
                  onClick={openModal}
                  style={{
                    backgroundColor: bookingButtonColor,
                    borderColor: bookingButtonColor,
                    boxShadow: `0 4px 15px ${bookingButtonColor}40`,
                  }}
                >
                  {bookingButtonText}
                </button>
              </div>
            )}

            {/* Read More Button (if needed) */}
            {buttonText && buttonLink && (
              <a href={buttonLink} className='hero-button'>
                {buttonText}
              </a>
            )}
          </div>
        </div>
      </section>

      {/* Booking Modal Component */}
      <BookingModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Hero;
